// extracted by mini-css-extract-plugin
module.exports = {"card":"EsiaConsentBanner_card__fylHj","img":"EsiaConsentBanner_img__iNhxg","text":"EsiaConsentBanner_text__9_8T0","button":"EsiaConsentBanner_button__pd_Og"};